// Libraries
import React from 'react';
import ReactPlayer from 'react-player';
// Components
import { Button, ButtonSectionIcon } from '@components/button';
import { ModalInformationImportant } from '../../components';
// Pages
import { CurrentInformation } from '@pages/electronic-payroll/constants/InformationImportant';
import { useEnablePayroll } from '@pages/electronic-payroll/hooks/useEnablePayroll';
import { useModalInformationImportant } from '@pages/electronic-payroll/hooks/useModalInformationImportant';
import { useElectronicPayroll } from '@pages/electronic-payroll/hooks/useElectronicPayroll';
import { CurrentTabs } from '@pages/electronic-payroll/constants/Tabs';
// Utils
import { checkIsSupport } from '@utils/CheckSupport';
// Styles
import './EnablePayroll.scss';
// Assets
import banner from '@assets/logos/buy-electronic-payroll.png';
import { Loader } from '@components/loader';
import { ModalImportantInfo } from '@components/modal';
import { ELECTRONIC_PAYROLL_SERVICE_ERROR } from '@pages/electronic-payroll/constants/Transmit';

export const EnablePayroll: React.FC = () => {
    const { handleChangeTab, handleBuyPayroll, companyInformation, full_functionality_avaiable, activePlan } =
        useElectronicPayroll();
    const {
        hasElectronicPayroll,
        token,
        showErrorModal,
        showLoaderElectronicPayroll,
        handleStartTransmit,
        handleCheckElectronicPayrollStatus,
    } = useEnablePayroll();
    const {
        showModalImportant,
        currentInformation,
        handleShowModalImportant,
        handleSelectTypeInformation,
        handleRedirectionModalInformation,
    } = useModalInformationImportant();

    return (
        <div className="enable-payroll">
            <ModalInformationImportant
                isOpen={showModalImportant}
                onRequestClose={handleShowModalImportant}
                hiddenBackButton={currentInformation === CurrentInformation.TRANSMITION_REDIRECT}
                handleBack={handleShowModalImportant}
                mainAction={(): void => {
                    if (currentInformation === CurrentInformation.TRANSMISSION_SERVICE) {
                        handleChangeTab(CurrentTabs.TRANSMIT_ELECTRONIC_PAYROLL);
                        handleStartTransmit();
                        handleShowModalImportant();
                    } else if (currentInformation === CurrentInformation.TRANSMITION_REDIRECT) {
                        handleShowModalImportant();
                        handleCheckElectronicPayrollStatus();
                    } else {
                        window.open(`${process.env.REACT_APP_ELECTRONIC_PAYROLL_DETAIL}${token}/1`, '_blank', 'noreferrer');
                        handleRedirectionModalInformation();
                    }
                }}
                currentInformation={currentInformation}
            />
            <Loader isOpen={showLoaderElectronicPayroll} />
            <ModalImportantInfo
                isOpen={showErrorModal}
                hiddenBackButton={true}
                confirm={true}
                mainAction={(): void => {
                    handleCheckElectronicPayrollStatus();
                }}
            >
                <p>{ELECTRONIC_PAYROLL_SERVICE_ERROR}</p>
            </ModalImportantInfo>
            {!activePlan?.electronic_payroll ? (
                <div className="container__banner">
                    <img src={banner} alt="banner-electronic-payroll" />
                    <div className="container__banner--description">
                        <div className="text-description">
                            Para hacer uso de la herramienta de <span>Nómina Electrónica</span> te invitamos hacer la compra de un
                            nuevo plan en el que se incluya esta funcionalidad
                        </div>
                        <div className="button__container">
                            <ButtonSectionIcon
                                classButtonSectionIconContainer="prueba"
                                onClick={handleBuyPayroll}
                                iconName={'moneyLightGreen'}
                                className={
                                    !full_functionality_avaiable ? 'button__container--disabled' : 'button__container--active'
                                }
                                disabled={!full_functionality_avaiable}
                            >
                                {'Comprar'}
                            </ButtonSectionIcon>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container__tabs">
                    <div className="container__description">
                        <p className="description--text">
                            Bienvenido al módulo de Nómina Electrónica, a través del cual puedes detallar el resumen de la
                            transmisión de tu nómina electrónica. Una vez compruebes la información puedes confirmar la
                            transmisión.
                        </p>
                        <p className="description--text">
                            Es importante tener en cuenta que cualquier tema relacionado con la modificación, eliminación,
                            consulta de detalles e históricos de las transmisiones, debe ser manejado desde el portal de Nómina
                            Electrónica. Se recomienda mirar el video para obtener más información al respecto.
                        </p>
                        <div className="container__button">
                            <Button
                                disabled={!full_functionality_avaiable || checkIsSupport(companyInformation)}
                                className={`${
                                    !full_functionality_avaiable ? 'container__buttons--disabled' : 'container__buttons--active'
                                }`}
                                onClick={(): void => {
                                    handleSelectTypeInformation(
                                        CurrentInformation[
                                            hasElectronicPayroll
                                                ? CurrentInformation.TRANSMISSION_SERVICE
                                                : CurrentInformation.ENABLE_SERVICE
                                        ]
                                    );
                                    handleShowModalImportant();
                                }}
                            >
                                Transmitir nómina electrónica
                            </Button>
                        </div>
                    </div>
                    <div className="container__video">
                        <ReactPlayer
                            muted
                            playing
                            url="/videos/nomina_electronica_v3.mp4"
                            width="100%"
                            controls
                            data-testid="video-player"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
